var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"text-xs flex w-6 h-6 bg-white border border-gray-500 hover:bg-white  hover:shadow rounded-full"},_vm.inputListeners),[_c('div',{staticClass:"m-auto"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }